module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
    var util = require('util/Util.js').default;    

    ; __append("\r\n<div class=\"row\">\r\n    <div class=\"col-md-4 prop-sublabel\">Name</div>\r\n    <div class=\"col-md-8\"><input type=\"text\" name=\"name\" class=\"app-name\" value=\"")
    ; __append(escapeFn( name ))
    ; __append("\" /></div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-4 prop-sublabel\">Title</div>   \r\n        <div class=\"col-md-8\"><input type=\"text\" name=\"title\" class=\"app-title translatable\" data-attr=\"title\" value=\"")
    ; __append(escapeFn( title ))
    ; __append("\" /></div>   \r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-4 prop-sublabel\">Version</div>\r\n    <div class=\"col-md-8 prop-sublabel version\">")
    ; __append(escapeFn( version ))
    ; __append("</div>\r\n</div>\r\n\r\n<!--\r\n PF-2605. Hide this property for now. This should be reactivated later on during the process-\r\n Please DON'T REMOVE THIS.\r\n-->\r\n<!--div class=\"row\">\r\n    <div class=\"col-md-12 form-group-flex\" style=\"padding-top: 18px; \">\r\n        <input  type=\"checkbox\" id=\"isResponsive\" name=\"isResponsive\" class=\"form-radio-group\"/>\r\n        <label style=\"padding-left: 5px; margin-top: 3px; font-size: 1.2rem;\" class=\"form-group-label\">Allow Mobile Display</label>\r\n    </div>\r\n</--div>")
  }
  return __output;

}